import { Permission } from '@insio/shared-types';
import { usePermissions } from '@/features/auth';

/**
 * Whether the user may run the admin-gated chat prompts. Checks account.settings, held by the
 * same roles as the integrations.manage and users.manage gates of the sync and user tools.
 */
export function useCanUseAdminPrompts(): boolean {
  const { hasPermission } = usePermissions();
  return hasPermission(Permission.ACCOUNT_SETTINGS);
}
